import React from 'react';
import { Form } from '@/pages/waiting/tutorial';
import { ReactComponent as ArrowDown } from '@/assets/images/icons/Arrow_Down.svg';
import BottomScrollPicker from '@/components/BottomScrollPicker/BottomScrollPicker';

interface TutorialStep6Props {
  form: Form;
  setForm: (key: keyof Form, value: any) => () => void;
}

const OPTION_GROUPS = Array.from({ length: 8 }, (_, i) => `${(i + 1) * 5}분`);

const TutorialStep6: React.FC<TutorialStep6Props> = ({ form, setForm }) => {
  const [isPickerOpen, setIsPickerOpen] = React.useState(false);
  return (
    <>
      <div className="p-5 flex flex-col mb-[40px]">
        <p className="text-zinc-800 text-[28px] font-medium mb-[8px] leading-10">
          매장 입장 요청 후<br />몇 분이 지나면 대기를
          <br />
          자동으로 취소할까요?
        </p>
      </div>
      <div className="p-5 flex flex-col gap-y-3 text-zinc-800 text-xl font-medium">
        <p>매장에 입장 요청 후</p>
        <div className="flex gap-x-3 items-center">
          <div
            onClick={() => {
              setIsPickerOpen(true);
            }}
            className="text-sm font-medium w-[120px] justify-between flex px-3 py-2 gap-2 rounded border border-stone-300 items-center"
          >
            <span>{form.callExpiredMinute?.split('분')[0]}</span>
            <ArrowDown className="w-6 h-6" />
          </div>
          <span>분이 지나면</span>
        </div>
        <p>대기가 자동으로 취소됩니다.</p>
      </div>
      <BottomScrollPicker
        title="호출 후 경과 시간"
        tabletCustomInformationMessage="호출 후 몇 분이 지나면 대기를 취소할까요?"
        onDismiss={() => setIsPickerOpen(false)}
        value={form.callExpiredMinute}
        isOpen={isPickerOpen}
        list={OPTION_GROUPS}
        onSelectedSave={(selected) => setForm('callExpiredMinute', selected)()}
      />
    </>
  );
};

export default TutorialStep6;
